import { Component, effect, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { HioUserinfoModule } from '@hio/userinfo';
import { JApiService, JAuthService } from '@j/api';

@Component({
    selector: 'j-app',
    // animations: [routeAnimations],
    styles: [
        `
        :host {
          flex: 1;
          display: block;
        }
      `
    ],
    template: `

<main jcApp style="height: 100%;"> <!-- [@routeAnimations]="prepareRoute(outlet)"  -->
  <router-outlet #outlet="outlet"></router-outlet>
</main>

<lib-hio-userinfo></lib-hio-userinfo>


    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HioUserinfoModule, RouterModule]
},

) //  [ngStyle]="{'display': getDisplayState()}"
export class AppComponent implements OnInit {
  public apptoken = 'Hjftvrh4';
  public startURL: string | null = null;

  constructor(public router: Router,
              public auth: JAuthService,
              public api: JApiService
              ) {
    this.startURL = window.location.href;
    this.auth.useLoginApp = false;
    this.auth.init(this.apptoken, 'insight');
    this.setMandantByUrl();

    // Beim initialen Laden ohne Token wird der Mandant durch goToLogin() wieder
    // geleert. Sobald nach der Anmeldung die Mandantenliste vorliegt, den
    // Mandanten erneut aus der URL setzen, damit der Access-Token angefordert wird.
    effect(() => {
      if (this.auth.mandanten())
        this.setMandantByUrl();
    });
  }


  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  ngOnInit() {
    this.api.isLogin.subscribe(val => {
      if (val)
        this.setMandantByUrl();
    });
  }

  private getKnrmandantFromUrl(): number {
    let url = window.location.href;
    let urlArr = url.split('#');
    if (urlArr[1] !== undefined) {
      let pathArr = urlArr[1].split('/');
      if (pathArr[1] !== undefined)
        return Number(pathArr[1]);
    }
    return null;
  }

  private setMandantByUrl() {
    const knr = this.getKnrmandantFromUrl();
    if (knr != this.auth.mandant.value)
      this.auth.mandant.next(knr);
  }

}
